import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import "./ConnectedServices.css";
import "./HomePageService.css";

const connectedServices = [
  {
    id: "shopify",
    title: "Shopify Development",
    primary: true,
    icon: (
      // Official Shopify logo
      <svg
        viewBox="0 0 109.5 124.5"
        width="40"
        height="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#95BF47"
          d="M74.7 14.8s-1.4.4-3.7 1.1c-.4-1.3-1-2.8-1.8-4.4-2.6-5-6.5-7.7-11.1-7.7-.3 0-.6 0-1 .1-.1-.2-.3-.3-.4-.5-2-2.2-4.6-3.2-7.7-3.1-6 .2-12 4.5-16.8 12.2-3.4 5.4-6 12.2-6.7 17.4-6.9 2.1-11.7 3.6-11.8 3.7-3.5 1.1-3.6 1.2-4 4.5C9.4 40.7 0 116.2 0 116.2l75.6 13.1V14.4c-.3.1-.6.2-.9.4zm-18 5.5c-4 1.2-8.4 2.6-12.7 3.9 1.2-4.7 3.6-9.4 6.4-12.5 1.1-1.1 2.6-2.4 4.3-3.2 1.7 3.5 2.1 8.3 2 11.8zm-8.2-15.8c1.4 0 2.6.3 3.6.9-1.6.8-3.2 2.1-4.7 3.6-3.8 4.1-6.7 10.5-7.9 16.6-3.6 1.1-7.2 2.2-10.5 3.2C31 19.7 38.8 4.8 48.5 4.5z"
        />
        <path
          fill="#5E8E3E"
          d="M93.5 12.4c-.4 0-7.4-.1-7.4-.1s-5.9-5.7-6.5-6.3c-.2-.2-.4-.3-.6-.3V129.3l30.5-7.6S96.5 14.1 96.4 13.3c-.2-.6-.5-.9-.9-.9z"
        />
        <path
          fill="#FFFFFF"
          d="M58.2 43.1l-3.6 13.3s-4-1.8-8.7-1.5c-6.9.4-7 4.8-6.9 5.9.4 6.3 17 7.7 17.9 22.5.7 11.6-6.2 19.6-16.2 20.2-12 .7-18.6-6.3-18.6-6.3l2.5-10.7s6.6 5 11.9 4.7c3.5-.2 4.7-3 4.6-5-.5-8.2-14-7.7-14.8-21.3-.7-11.4 6.8-23 23.4-24 6.5-.4 9.5 1.2 9.5 1.2z"
        />
      </svg>
    ),
    desc: "Full-stack Shopify development — custom themes, Shopify Plus, Hydrogen headless, CRO optimization, and subscription architecture. We build stores that generate 6-figure revenue.",
    tags: [
      "Custom Theme Development",
      "Shopify Plus & Hydrogen",
      "CRO & Speed Optimization",
      "Subscription & Quiz Funnels",
      "Figma to Shopify (Pixel-Perfect)",
    ],
    link: "/services/shopify-development",
    ctaText: "Explore Shopify Services",
    stats: [
      { value: "150+", label: "projects" },
      { value: "100%", label: "satisfaction" },
    ],
  },
  {
    id: "wordpress",
    title: "WordPress & WooCommerce",
    primary: false,
    icon: (
      // Official WordPress logo
      <svg
        viewBox="0 0 122.52 122.523"
        width="40"
        height="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fill="#21759B"
            d="M8.708 61.26c0 20.802 12.089 38.779 29.619 47.298L13.258 39.872C10.342 46.217 8.708 53.251 8.708 61.26zM96.74 58.608c0-6.495-2.333-10.993-4.334-14.494-2.664-4.329-5.161-7.995-5.161-12.324 0-4.831 3.664-9.328 8.825-9.328.233 0 .454.029.681.042-9.35-8.566-21.807-13.796-35.489-13.796-18.36 0-34.513 9.42-43.91 23.688 1.233.037 2.395.063 3.382.063 5.497 0 14.006-.667 14.006-.667 2.833-.167 3.167 3.994.337 4.329 0 0-2.847.335-6.015.501L48.2 93.547l11.501-34.493-8.188-22.434c-2.83-.166-5.511-.501-5.511-.501-2.832-.166-2.5-4.496.332-4.329 0 0 8.679.667 13.843.667 5.496 0 14.006-.667 14.006-.667 2.835-.167 3.168 3.994.337 4.329 0 0-2.853.335-6.015.501l18.992 56.494 5.242-17.517c2.272-7.269 4.001-12.49 4.001-16.989z"
          />
          <path
            fill="#21759B"
            d="M62.184 65.857l-15.768 45.819c4.708 1.384 9.687 2.141 14.846 2.141 6.12 0 11.989-1.058 17.452-2.979-.141-.225-.269-.464-.374-.724L62.184 65.857zM107.376 36.046c.226 1.674.355 3.471.355 5.405 0 5.33-.996 11.328-3.997 18.824l-16.053 46.413c15.624-9.111 26.133-26.038 26.133-45.428-.001-9.137-2.333-17.729-6.438-25.214z"
          />
          <path
            fill="#21759B"
            d="M61.262 0C27.483 0 0 27.481 0 61.26c0 33.783 27.483 61.263 61.262 61.263 33.778 0 61.265-27.48 61.265-61.263C122.527 27.481 95.04 0 61.262 0zM61.262 119.715c-32.23 0-58.453-26.222-58.453-58.455 0-32.23 26.222-58.451 58.453-58.451 32.229 0 58.45 26.221 58.45 58.451 0 32.233-26.221 58.455-58.45 58.455z"
          />
        </g>
      </svg>
    ),
    desc: "Custom WordPress themes, WooCommerce stores, membership sites, and high-performance blogs built for scale and SEO dominance.",
    tags: [
      "Custom Theme Development",
      "WooCommerce Stores",
      "SEO-Optimized Architecture",
      "Plugin Development",
    ],
    link: "/services/wordpress-development",
    ctaText: null,
    stats: [
      { value: "8+", label: "projects" },
      { value: "100%", label: "satisfaction" },
    ],
  },
  {
    id: "mobile",
    title: "Mobile App Development",
    primary: false,
    icon: (
      // React Native official logo
      <svg
        viewBox="-11.5 -10.23 23 20.46"
        width="40"
        height="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="0" cy="0" r="2.05" fill="#61DAFB" />
        <g stroke="#61DAFB" strokeWidth="1" fill="none">
          <ellipse rx="11" ry="4.2" />
          <ellipse rx="11" ry="4.2" transform="rotate(60)" />
          <ellipse rx="11" ry="4.2" transform="rotate(120)" />
        </g>
      </svg>
    ),
    desc: "Native and cross-platform mobile apps for iOS and Android — from concept to App Store launch, with ongoing support.",
    tags: [
      "React Native / Flutter",
      "iOS & Android Native",
      "App Store Optimization",
      "Push & Analytics",
    ],
    link: "/services/mobile-app-development",
    ctaText: null,
    stats: [
      { value: "6+", label: "projects" },
      { value: "100%", label: "satisfaction" },
    ],
  },
  {
    id: "software",
    title: "Custom Software Development",
    primary: false,
    icon: (
      // Node.js official logo
      <svg
        viewBox="0 0 256 289"
        width="40"
        height="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#539E43"
          d="M128 288.464c-3.975 0-7.685-1.06-11.13-2.915l-35.247-20.936c-5.3-2.915-2.65-3.975-1.06-4.505 7.155-2.385 8.48-2.915 15.9-7.155.795-.53 1.855-.265 2.65.265l27.032 16.166c1.06.53 2.385.53 3.18 0l105.74-61.217c1.06-.53 1.59-1.59 1.59-2.915V83.08c0-1.325-.53-2.385-1.59-2.915L128.795 19.213c-1.06-.53-2.385-.53-3.18 0L19.874 80.165c-1.06.53-1.59 1.855-1.59 2.915v122.434c0 1.06.53 2.385 1.59 2.915l28.887 16.695c15.635 7.95 25.44-1.325 25.44-10.6V94.74c0-1.59 1.325-3.18 3.18-3.18h13.78c1.59 0 3.18 1.325 3.18 3.18v119.79c0 20.936-11.395 32.86-31.27 32.86-6.095 0-10.865 0-24.38-6.625l-27.827-16.0c-6.89-3.975-11.13-11.395-11.13-19.345V83.08c0-7.95 4.24-15.37 11.13-19.345L116.87 2.518c6.625-3.71 15.635-3.71 22.26 0l105.74 61.217c6.89 3.975 11.13 11.395 11.13 19.345v122.434c0 7.95-4.24 15.37-11.13 19.345l-105.74 61.217c-3.445 1.59-7.42 2.385-11.13 2.385v.003z"
        />
        <path
          fill="#539E43"
          d="M160.398 204.794c-46.283 0-55.954-21.2-55.954-39.017 0-1.59 1.325-3.18 3.18-3.18h14.045c1.59 0 2.915 1.06 2.915 2.65 2.12 14.045 8.215 20.936 35.814 20.936 22.26 0 31.535-5.035 31.535-16.96 0-6.89-2.65-11.925-37.404-15.37-29.152-2.915-47.078-9.275-47.078-32.595 0-21.466 18.02-34.22 48.138-34.22 33.92 0 50.88 11.66 52.997 37.1.265.795 0 1.59-.265 2.385-.53.53-1.325 1.06-2.12 1.06h-14.31c-1.325 0-2.65-1.06-2.915-2.385-3.18-14.575-11.395-19.345-33.39-19.345-24.645 0-27.56 8.48-27.56 14.84 0 7.685 3.445 9.805 36.344 14.045 32.595 4.24 48.138 10.335 48.138 33.655 0 23.32-19.345 36.4-53.11 36.4z"
        />
      </svg>
    ),
    desc: "Bespoke web applications, SaaS platforms, APIs, dashboards, and automation tools built to your exact specifications.",
    tags: [
      "Full-Stack Web Apps",
      "SaaS & Dashboard",
      "API & Integration",
      "Database Architecture",
    ],
    link: "/services/custom-software",
    ctaText: null,
    stats: [
      { value: "10+", label: "projects" },
      { value: "100%", label: "satisfaction" },
    ],
  },
  {
    id: "data",
    title: "Data & Analytics",
    primary: false,
    icon: (
      // Google Analytics official logo
      <svg
        viewBox="0 0 64 64"
        width="40"
        height="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#F9AB00"
          d="M44 56V8a4 4 0 014-4h4a4 4 0 014 4v48a4 4 0 01-4 4h-4a4 4 0 01-4-4z"
        />
        <path
          fill="#E37400"
          d="M26 56V32a4 4 0 014-4h4a4 4 0 014 4v24a4 4 0 01-4 4h-4a4 4 0 01-4-4z"
        />
        <circle fill="#E37400" cx="12" cy="52" r="8" />
      </svg>
    ),
    desc: "Turn raw data into actionable insights — custom dashboards, GA4 setup, tracking architecture, and business intelligence solutions.",
    tags: [
      "Custom Dashboards",
      "GA4 & Tag Manager",
      "Data Visualization",
      "Business Intelligence",
    ],
    link: "/services/data-analytics",
    ctaText: null,
    stats: [
      { value: "7+", label: "projects" },
      { value: "100%", label: "satisfaction" },
    ],
  },
  {
    id: "uiux",
    title: "UI/UX Design",
    primary: false,
    icon: (
      // Official Figma logo
      <svg
        viewBox="0 0 38 57"
        width="40"
        height="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="#1ABCFE" d="M19 28.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z" />
        <path
          fill="#0ACF83"
          d="M0 47.5A9.5 9.5 0 019.5 38H19v9.5a9.5 9.5 0 01-19 0z"
        />
        <path fill="#FF7262" d="M19 0v19h9.5a9.5 9.5 0 000-19H19z" />
        <path
          fill="#F24E1E"
          d="M0 9.5A9.5 9.5 0 009.5 19H19V0H9.5A9.5 9.5 0 000 9.5z"
        />
        <path
          fill="#A259FF"
          d="M0 28.5A9.5 9.5 0 009.5 38H19V19H9.5A9.5 9.5 0 000 28.5z"
        />
      </svg>
    ),
    desc: "Research-driven interface design that converts — wireframes, prototypes, design systems, and conversion-focused user experiences.",
    tags: [
      "Figma & Sketch Design",
      "Design Systems",
      "User Research & Testing",
      "Conversion-Focused UX",
    ],
    link: "/services/uiux-design",
    ctaText: null,
    stats: [
      { value: "5+", label: "projects" },
      { value: "100%", label: "satisfaction" },
    ],
  },
];

export default function ConnectedServices({
  ctaLabel = "Explore Full Service Suite",
  ctaLink = "/services",
}) {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cs-visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" },
    );

    const section = sectionRef.current;
    if (section) observer.observe(section);
    cardsRef.current.forEach((card) => card && observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="cs-section" ref={sectionRef}>
      <div className="cs-container">
        {/* Header */}
        <div className="cs-header">
          <h2 className="cs-heading">
            Full-Spectrum Digital Services
            <br />
            <span className="cs-heading-accent">
              {" "}
              Built for Ambitious Brands
            </span>
          </h2>
          <p className="cs-subheading">
            From Shopify stores to mobile apps, custom software to data
            analytics — everything your business needs under one roof.
          </p>
        </div>

        {/* Grid */}
        <div className="cs-grid">
          {connectedServices.map((service, i) => (
            <Link
              to={service.link}
              key={service.id}
              className={`cs-card ${service.primary ? "cs-card--primary" : ""}`}
              ref={(el) => (cardsRef.current[i] = el)}
              style={{ "--delay": `${i * 0.08}s`, textDecoration: "none" }}
              data-service={service.id}
            >
              {/* Primary badge */}
              {service.primary && <span className="cs-badge">PRIMARY</span>}

              {/* Icon */}
              <div
                className={`cs-icon ${service.primary ? "cs-icon--primary" : ""}`}
              >
                {service.icon}
              </div>

              {/* Content */}
              <h3 className="cs-card-title">{service.title}</h3>
              <p className="cs-card-desc">{service.desc}</p>

              {/* Tags */}
              <div className="cs-tags">
                {service.tags.map((tag, j) => (
                  <span
                    key={j}
                    className={`cs-tag ${service.primary ? "cs-tag--primary" : ""}`}
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* CTA + Stats */}
              {(service.ctaText || service.stats) && (
                <div className="cs-card-footer">
                  {service.ctaText && (
                    <span className="cs-cta-link">
                      {service.ctaText} <span className="cs-arrow">→</span>
                    </span>
                  )}
                  {service.stats && (
                    <div className="cs-stats">
                      {service.stats.map((stat, k) => (
                        <span key={k} className="cs-stat">
                          <strong>{stat.value}</strong> {stat.label}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="cs-cta-wrap">
          {ctaLink.startsWith("#") ? (
            <a href={ctaLink} className="srv-btn">
              <span className="srv-btn-text">{ctaLabel}</span>
              <span className="srv-btn-icon">
                <svg viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10h12M11 5l5 5-5 5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="srv-btn-shine" />
            </a>
          ) : (
            <Link to={ctaLink} className="srv-btn">
              <span className="srv-btn-text">{ctaLabel}</span>
              <span className="srv-btn-icon">
                <svg viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10h12M11 5l5 5-5 5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="srv-btn-shine" />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
